export default __webpack_public_path__ + "static/media/layout-1 (6).5ee92fa3.jpg";